import { graphql, HttpResponse } from 'msw';
import type { PostArtistPerformanceContentMutation } from '@/__generated__/graphql';

export const postArtistPerformanceContent = graphql.mutation<PostArtistPerformanceContentMutation>(
  'PostArtistPerformanceContent',
  (req) => {
    const { input } = req.variables;
    const { body, channelID, isSpoiler, parentContentID, tempImages } = input;
    const isRegistered = true;
    const now = new Date().toISOString();

    const newPost = {
      __typename: 'ArtistPost' as const,
      ulid: `mock-artist-post-${Date.now()}`,
      channelID,
      body,
      isSpoiler: isSpoiler ?? false,
      isMasked: false,
      createdAt: now,
      updatedAt: now,
      images:
        tempImages?.map((img: { url: string; id?: string }, index: number) => ({
          __typename: 'Image' as const,
          id: `image-${index}`,
          url: img.url,
        })) || [],
      artistOfficial: {
        __typename: 'ArtistOfficial' as const,
        id: 'artist-001',
        name: 'モックアーティスト',
        iconImage: null,
      },
      reactions: {
        __typename: 'ArtistPostReactions' as const,
        reactionCounts: [],
        myReactions: isRegistered ? [] : null,
        artistReactions: [],
      },
      parentContent: parentContentID
        ? {
            __typename: 'FanPost' as const,
            channelID,
            ulid: parentContentID,
            body: '返信元モック投稿',
            isSpoiler: false,
            isMasked: false,
            fan: {
              __typename: 'Fan' as const,
              id: 'fan-parent',
              iconImage: null,
            },
          }
        : null,
    };

    return HttpResponse.json({
      data: {
        __typename: 'Mutation',
        postArtistPerformanceContent: {
          __typename: 'PostArtistPerformanceContentPayloadSuccess' as const,
          ok: true,
          post: newPost,
        },
      },
    });
  },
);
